import {Box, Input, useMenuItem} from "@chakra-ui/react";

const navigationKeys = ['ArrowUp', 'ArrowDown', 'Escape'];

export const MenuInput = props => {
    const {role, ...rest} = useMenuItem(props);
    return (
        <Box px="3" role={role}>
            <Input
                placeholder={props.placeHolder}
                aria-label={props.placeHolder}
                size="sm"
                {...rest}
                onKeyDown={e => {
                    if (!navigationKeys.includes(e.key)) {
                        e.stopPropagation();
                    }
                }}
                onChange={props.changeInput}
            />
        </Box>
    );
};